// src/pages/Store/components/desktop/DesktopHeader.tsx
import React from "react";
import { useTheme } from "styled-components";
import { IStore } from "../../../../classes/interfaces";
import Icon from "../../../../components/ui/Icon";
import Logo from "../../../../components/ui/Logo";
import {
  Header,
  Inner,
  LocationChip,
  LocationText,
  LocationLabel,
  LocationValue,
  SearchBox,
  SearchInput,
  ClearButton,
  CartButton,
  OrdersButton,
  Badge,
} from "./DesktopHeader.styles";

interface DesktopHeaderProps {
  company?: IStore;
  tableId?: string;
  count: number;
  query: string;
  onQueryChange: (query: string) => void;
  /** Ausente no cardápio-vitrine (/menu): sem sacola, o botão some. */
  onCart?: () => void;
  onOrders?: () => void;
  onLogo?: () => void;
}

export default function DesktopHeader({
  company,
  tableId,
  count,
  query,
  onQueryChange,
  onCart,
  onOrders,
  onLogo,
}: DesktopHeaderProps) {
  const theme = useTheme();
  const hasLocation = tableId || (company && company.district && company.city);

  return (
    <Header>
      <Inner>
        <Logo size={26} light onClick={onLogo} />
        {hasLocation && (
          <LocationChip>
            <Icon name="pin" size={17} color="#fff" />
            <LocationText>
              {tableId ? (
                <>
                  <LocationLabel>Você está na</LocationLabel>
                  <LocationValue>Mesa {tableId}</LocationValue>
                </>
              ) : (
                <>
                  <LocationLabel>Endereço</LocationLabel>
                  <LocationValue>{`${company!.district} · ${company!.city.name}`}</LocationValue>
                </>
              )}
            </LocationText>
          </LocationChip>
        )}
        <SearchBox>
          <Icon name="search" size={19} color="#9AA8A3" />
          <SearchInput
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            placeholder="Buscar pratos, bebidas…"
            aria-label="Buscar no cardápio"
          />
          {query && (
            <ClearButton type="button" aria-label="Limpar busca" onClick={() => onQueryChange("")}>
              <Icon name="x" size={13} strokeWidth={2.4} color={theme.tokens.colors.muted} />
            </ClearButton>
          )}
        </SearchBox>
        {onOrders && (
          <OrdersButton type="button" onClick={onOrders} aria-label="Meus pedidos">
            <Icon name="receipt" size={19} color={theme.tokens.colors.surface} />
            Meus pedidos
          </OrdersButton>
        )}
        {onCart && (
          <CartButton type="button" onClick={onCart} aria-label="Ir para o carrinho">
            <Icon name="bag" size={19} color={theme.tokens.colors.surface} />
            Sacola
            {count > 0 && <Badge>{count}</Badge>}
          </CartButton>
        )}
      </Inner>
    </Header>
  );
}
